/* [RR feat] Rezeptseite: Portionen umrechnen. Die Mengen stehen als Text in der
   Zutatenliste („600 g Kartoffeln“, „½ Zitrone“, „1-2 EL Olivenöl“); das Skript
   skaliert alle Zahlen der Zeile, Bereiche („1-2 EL“) als Paar. Zeilen ohne Zahl
   (Salz, Pfeffer) bleiben, wie sie sind. */
(function () {
  'use strict';

  var FRAC = { '½': 0.5, '¼': 0.25, '¾': 0.75, '⅓': 1 / 3, '⅔': 2 / 3, '⅛': 0.125 };
  var NUM = '(\\d+(?:[.,]\\d+)?\\s*[½¼¾⅓⅔⅛]|\\d+\\s*/\\s*\\d+|\\d+(?:[.,]\\d+)?|[½¼¾⅓⅔⅛])';
  var ALL = new RegExp(NUM + '\\s*[-–]\\s*' + NUM + '|' + NUM, 'g');

  function toNumber(str) {
    str = str.trim();
    var m = /^(\d+(?:[.,]\d+)?)\s*([½¼¾⅓⅔⅛])$/.exec(str);
    if (m) return parseFloat(m[1].replace(',', '.')) + FRAC[m[2]];
    if (FRAC[str] !== undefined) return FRAC[str];
    m = /^(\d+)\s*\/\s*(\d+)$/.exec(str);
    if (m) return Number(m[1]) / Number(m[2]);
    return parseFloat(str.replace(',', '.'));
  }

  /* Hübsch runden: ganze Zahlen, sonst Viertelschritte als Bruch, große Mengen ganz */
  function format(n) {
    if (n >= 10) return String(Math.round(n));
    var whole = Math.floor(n), rest = n - whole;
    var q = Math.round(rest * 4) / 4;
    if (q === 1) { whole += 1; q = 0; }
    var frac = { 0.25: '¼', 0.5: '½', 0.75: '¾' }[q] || '';
    if (!frac && q !== 0) return String(Math.round(n * 10) / 10).replace('.', ',');
    if (whole === 0 && frac) return frac;
    return whole + (frac ? ' ' + frac : '');
  }

  /* Alle Zahlen der Zeile skalieren, Bereiche („1-2 EL“) als Paar */
  function scale(text, factor) {
    return text.replace(ALL, function (match, a, b, single) {
      if (single !== undefined) return format(toNumber(single) * factor);
      return format(toNumber(a) * factor) + '–' + format(toNumber(b) * factor);
    });
  }

  function init(box) {
    var base = parseInt(box.dataset.base, 10) || 2;
    var current = base;
    var out = box.querySelector('[data-rr-portionen-wert]');
    var unit = box.querySelector('[data-rr-portionen-einheit]');
    var minus = box.querySelector('[data-rr-portionen-minus]');
    var plus = box.querySelector('[data-rr-portionen-plus]');
    var label = document.querySelector('[data-rr-portionen-label]');
    var items = document.querySelectorAll('[data-rr-zutat]');

    function render() {
      var f = current / base;
      for (var i = 0; i < items.length; i++) items[i].textContent = f === 1 ? items[i].dataset.rrZutat : scale(items[i].dataset.rrZutat, f);
      out.textContent = current;
      var word = current === 1 ? 'Portion' : 'Portionen';
      if (unit) unit.textContent = word;
      if (label) label.textContent = 'für ' + current + ' ' + word;
      minus.disabled = current <= 1;
      plus.disabled = current >= 12;
    }
    minus.addEventListener('click', function () { if (current > 1) { current--; render(); } });
    plus.addEventListener('click', function () { if (current < 12) { current++; render(); } });
    render();
  }

  var boxes = document.querySelectorAll('[data-rr-portionen]');
  for (var i = 0; i < boxes.length; i++) init(boxes[i]);

  /* --- Slideshow im Hero: Pfeile, Punkte, Wischen (Scroll-Snap) ----------- */
  class RrSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rr-slides]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.rr-rp__slide'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-rr-dot]'));
      if (!this.track || this.slides.length < 2) return;
      this.index = 0;
      this.querySelector('[data-rr-prev]').addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-rr-next]').addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(Number(d.dataset.rrDot))));
      this.track.addEventListener('scroll', () => { clearTimeout(this.t); this.t = setTimeout(() => this.sync(), 80); }, { passive: true });
      this.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') this.go(this.index - 1); if (e.key === 'ArrowRight') this.go(this.index + 1); });
      this.tabIndex = 0;
    }
    go(i) {
      var n = this.slides.length;
      i = (i + n) % n;
      this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: 'smooth' });
      this.mark(i);
    }
    sync() { this.mark(Math.round(this.track.scrollLeft / this.track.clientWidth)); }
    mark(i) {
      this.index = Math.max(0, Math.min(i, this.slides.length - 1));
      this.dots.forEach((d, k) => { var on = k === this.index; d.classList.toggle('is-active', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); });
    }
  }
  if (!customElements.get('rr-slideshow')) customElements.define('rr-slideshow', RrSlideshow);
})();
